import { render, staticRenderFns } from "./BannerRow.vue?vue&type=template&id=60f72191&scoped=true&"
import script from "./BannerRow.vue?vue&type=script&lang=js&"
export * from "./BannerRow.vue?vue&type=script&lang=js&"
import style0 from "./BannerRow.vue?vue&type=style&index=0&id=60f72191&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f72191",
  null
  
)

export default component.exports